import { Box, Button, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { useSubscriptionDetails } from '../../hooks/subscriptions'
import { subscriptionsPromoRoute } from '../../routes/routes'

export const HomeSubscription = ({ isSubscribedBefore }) => {
  const history = useHistory()

  const { subscriptionOffer } = useSubscriptionDetails()

  if (subscriptionOffer == null) {
    return (
      <>
        <Skeleton height={100} />
        <Skeleton height={50} />
        <Skeleton height={150} />
      </>
    )
  }
  return (
    <Box paddingRight={4}>
      <img
        alt=""
        className="-image"
        src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/home-subscription.png`}
        width="220"
      />
      <Box marginY={2}>
        <Typography variant="h6">Unlimited Free Delivery</Typography>
        <Typography component="p" gutterBottom variant="body1">
          Enjoy $0 delivery fees every time you order for just ${subscriptionOffer?.offer?.price}{' '}
          per month.{' '}
        </Typography>
      </Box>
      <Button
        color="primary"
        onClick={() => history.push(subscriptionsPromoRoute.path)}
        variant="contained"
      >
        {isSubscribedBefore ? 'Subscribe' : 'Try free for 30 days'}
      </Button>
    </Box>
  )
}

export default HomeSubscription
